<template>
    <div class="page-retrievePassword">
        <div class="content">
            <div class="top-info">
                <p class="title">
                    <router-link to="/login">
                        <!-- <i class="iconfont icon-xinxiwanglogo"></i> -->
                        <el-tooltip class="item" effect="dark" content="返回登录界面" placement="bottom">
                            <img src="@/assets/pics/zhmmlogo.png" alt="" />
                        </el-tooltip>
                    </router-link>
                    <span class="title_span fontsize-14">找回密码</span>
                    <router-link to="/login" class="back-login">
                        <span class="title_span fontsize-14">登陆</span>
                    </router-link>
                </p>
                <p class="phone">
                    <i class="iconfont icon-kefu1"></i>
                    <span>客服电话：028-69365269</span>
                </p>
            </div>

            <div class="box-card">
                <!-- step步骤 -->
                <permissionTopStep
                    :active-id="activeId"
                    :steps-arr="stepTitleArr"
                    @goClickStep="next('back')"
                ></permissionTopStep>
                <div v-if="!activeId">
                    <chooseWay :active-way-id="activeWayId" @goNext="next" @setType="setType"></chooseWay>
                </div>
                <div v-if="activeId == 1" class="input-content">
                    <inputContent :type="type" :banckdata="banckdata" @next="next" @savenext="savenext"></inputContent>
                    <!-- <inputContent
                        :type="type"
                        :banckdata="banckdata"
                        @goNext="next"
                        @savenext="savenext"
                    ></inputContent> -->
                </div>
                <div v-if="activeId == 2" class="input-content set-password">
                    <setPassword :type="type" :data="data" @next="next" @backData="backData"></setPassword>
                    <!-- <setPassword :type="type" :data="data" @goNext="next" @backData="backData"></setPassword> -->
                </div>
                <div v-if="activeId === 3" class="apply-success">
                    <p class="icon-success">
                        <i class="iconfont icon-xuanzhong"></i>
                    </p>
                    <p>密码修改成功!</p>
                    <p>
                        {{ auth_time }}秒后自动跳转到工作，若未跳转，可
                        <router-link to="/login">点击跳转</router-link>
                    </p>
                </div>
            </div>
        </div>
        <!-- <login-background></login-background> -->
    </div>
</template>
<script>
import chooseWay from "./choose-way";
import inputContent from "./input-content";
import setPassword from "./set-password";
// import LoginBackground from "@/components/login-background";
import permissionTopStep from "./permission-top-steps";
export default {
    components: {
        chooseWay,
        inputContent,
        setPassword,
        // LoginBackground,
        permissionTopStep,
    },
    data() {
        return {
            type: 1,
            activeId: 0,
            activeWayId: 0,
            auth_time: 5,
            data: {},
            banckdata: {},
            stepTitleArr: ["1.选择验证方式", "2.确认信息", "3.设置新密码", "4.完成"],
        };
    },
    computed: {
        step() {
            let step = [
                { title: "选择验证方式" },
                {
                    title: `确认${this.type === 1 ? "手机" : this.type === 0 ? "邮箱" : ""}信息`,
                },
                { title: "设置新密码" },
                { title: "完成" },
            ];
            return step;
        },
    },
    watch: {
        activeId(val) {
            if (val === 3) {
                let auth_timetimer = setInterval(() => {
                    this.auth_time--;
                    if (this.auth_time <= 0) {
                        this.$router.push({ path: "/login" });
                        clearInterval(auth_timetimer);
                    }
                }, 1000);
            }
        },
    },
    created() {},
    methods: {
        backData(res) {
            this.banckdata = res;
        },
        savenext(data) {
            this.data = data;
        },
        setType(type) {
            this.type = type;
        },
        next(flag) {
            if (flag === "back") {
                this.activeId--;
                if (this.type === 1) {
                    this.activeWayId = 0;
                } else {
                    this.activeWayId = 1;
                }
                return;
            }
            this.activeId++;
        },
    },
};
</script>
<style lang="scss" scoped>
.page-retrievePassword {
    // width: 100%;
    height: 100%;
    background: #f0f2f5;
    //display: flex;
    // flex-direction: row;
    // justify-content: center;
    //align-items: center;
    padding-top: 112px;

    // background-image: url("../assets/pics/dwwbimg.png");
    background-image: url("../../assets/pics/zhmmbg (1).png");

    background-position-x: center;
    background-position-y: center;
    background-size: 100% 100%;

    .content {
        width: calc(100%-320px);
        // position: relative;
        // padding-top: 112px;
        margin-left: 160px;
        margin-right: 160px;
        // border: 1px solid red;
        // position: absolute;
        // top: 15%;
        // right: 20%;
        height: 500px;
        z-index: 999;
        //background: rgba(255, 255, 255, 0.68);
        border-radius: 8px;
        // border: 1px solid rgba(255, 255, 255, 0.51);
        .top-info {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 20px;
        }
        .title {
            .iconfont {
                color: #fff;
                font-size: 24px;
                vertical-align: middle;
                padding-right: 10px;
                margin-right: 10px;
                border-right: 2px solid rgba(255, 255, 255, 0.4);
            }
            img {
                width: 192px;
                height: 40px;
                margin-right: 33px;
            }

            .title_span {
                display: inline-block;
                color: #fff;
                position: relative;
                top: -9px;
                // width: 113px;
                font-size: 20px;
                font-weight: 400;
                color: #666666;
                &::before {
                    content: "";
                    width: 2px;
                    height: 26px;
                    background: #d9d9d9;
                    position: absolute;
                    left: -14px;
                    top: 50%;
                    transform: translateY(-50%);
                }
            }
        }

        .phone {
            text-align: right;
            color: #666666;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            font-size: 16px;
            .icon-kefu1 {
                font-size: 22px;
                vertical-align: middle;
                margin-right: 12px;
            }
        }
        .back-to-login {
            width: 72px;
            line-height: 26px;
            background: #fff;
            border: 1px solid #cdcfd4;
            border-radius: 4px;
            text-align: center;
            font-size: 12px;
            position: absolute;
            top: 15px;
            left: 20px;
            cursor: pointer;
            &:hover {
                background: #29b294;
                color: #fff;
                border-color: #29b294;
            }
        }

        .box-card {
            // padding: 10px 0px 30px;
            padding-top: 10px;
            padding-left: 10px;
            // width: calc(100%-320px);
            // height: 703px;
            height: 500px;
            background: rgba(255, 255, 255, 0.68);
            border-radius: 11px;
            position: relative;
            // border: 1px solid rgba(255, 255, 255, 0.51);
            .email {
                margin-top: 10px;
                margin-bottom: 20px;
            }
        }
    }
    // .triangle {
    // }
    /deep/ .left-triangle {
        visibility: hidden !important;
    }
    /deep/.right-triangle {
        margin-right: 1px !important;
    }
    .el-button:hover,
    .el-button:focus {
        background: #25a589;
        color: #fff;
        border-color: #25a589;
    }

    .float_left {
        float: left;
    }
    .apply-success {
        display: flex;
        flex-direction: column;
        align-items: center;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        .icon-success {
            width: 72px;
            height: 72px;
            line-height: 72px;
            background: #40a082;
            border-radius: 50%;
            text-align: center;
            > i {
                color: #fff;
                font-size: 36px;
                position: relative;
                left: 6px;
            }
        }
        p {
            &:nth-child(2) {
                margin: 20px 0;

                font-size: 24px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: rgba(0, 0, 0, 0.85);
            }
            &:nth-child(3) {
                font-size: 14px;
                color: #999;
                > a {
                    color: $primary;
                    text-decoration: underline;
                }
            }
        }
    }

    .input-content {
        width: 500px;
        overflow: hidden;
        margin: 0 auto;
        margin-top: 84px;
        .but-item {
            margin: 72px 0 0;
            text-align: right;
        }
    }
}
</style>
<style lang="scss">
.page-retrievePassword {
    .is-finish {
        color: #000;

        .el-step__line {
            background: #25a589;
        }

        i {
            color: #25a589;
        }
    }
    .icon-xinxiwanglogo {
        color: #fff;
        &:hover {
            color: #25a589 !important;
        }
    }
    .back-login {
        display: inline-block;
        position: relative;
        margin-left: 30px;
        > span:hover {
            color: #25a589 !important;
        }
    }
}
</style>
